<div class="fx-modal-container">
    <form dw-form [formGroup]="myform" class="fx_form_content">
            <!-- <dw-form-item style="margin-bottom:40px;">
                    <dw-form-control>
                        <span class="input-group-addon change_password_title">用户</span>
                        <dw-input-group class="change_password_input"dwPrefixIcon="anticon "  >
                            <input dwSize="large" [type]= 'text' dw-input formControlName="userId"
                                placeholder="用户" disabled='true'>
                        </dw-input-group>
                       
                    </dw-form-control>
                </dw-form-item> -->
        <dw-form-item style="margin-bottom:40px;" *ngIf='!Flag'>
            <dw-form-control>
                <span class="input-group-addon change_password_title">旧密码</span>
                <dw-input-group class="change_password_input" dwPrefixIcon="anticon anticon-eye-o"
                    (click)="showPassword = !showPassword">
                    <input dwSize="large" [type]="showPassword ? 'text' : 'password'" dw-input formControlName="old_password"
                        placeholder="请输入原密码！">
                </dw-input-group>
                <dw-form-explain class="change_password_error"
                    *ngIf="myform.get('old_password').dirty && myform.get('old_password').errors">
                    必填</dw-form-explain>
            </dw-form-control>
        </dw-form-item>
        <dw-form-item style="margin-bottom:40px; ">
            <dw-form-control>
                <span class="input-group-addon change_password_title">新密码</span>
                <dw-input-group class="change_password_input" dwPrefixIcon="anticon anticon-eye-o"
                    (click)="showPassword1 = !showPassword1">
                    <input dwSize="large" [type]="showPassword1 ? 'text' : 'password'" dw-input formControlName="new_password" (ngModelChange)="setPwdvalidate()"
                        placeholder="请设置6~20位包含英文和数字组合"  >
                </dw-input-group>
                <dw-form-explain class="change_password_error"
                    *ngIf="myform.get('new_password').dirty && myform.get('new_password').errors">{{myform.get('new_password').errors.tips}}
                </dw-form-explain>
            </dw-form-control>
        </dw-form-item>
        <dw-form-item style="margin-bottom:40px; ">
            <dw-form-control>
                <span class="input-group-addon change_password_title">确认密码</span>
                <dw-input-group class="change_password_input" dwPrefixIcon="anticon anticon-eye-o"
                    (click)="showPassword2 = !showPassword2">
                    <input  dwSize="large" [type]="showPassword2 ? 'text' : 'password'" dw-input formControlName="sure_password" (ngModelChange)="setPwdvalidate()"
                        placeholder="请再次输入新密码">
                </dw-input-group>
                <dw-form-explain class="change_password_error"
                    *ngIf="myform.get('sure_password').dirty && myform.get('sure_password').errors">{{myform.get('sure_password').errors.tips}}
                </dw-form-explain>
            </dw-form-control>
        </dw-form-item>


        <!-- 
        <div class="fx_form_group">
            <div dw-row [dwType]="'flex'" [dwJustify]="'start'" [dwGutter]="10">
                <div dw-col>
                    <dw-form-input class="change_password_input" formControlName="userId" dwLabel="{{'用户' | translate}}"
                        ng-disabled="true" [dwRequired]="true">
                    </dw-form-input>
                </div> -->

        <!-- <div dw-col>
                   
                    <dw-form-input class="change_password_input" formControlName="old_password" dwLabel="{{'旧密码' | translate}}"
                        [dwRequired]="true">
                    </dw-form-input>
                </div> -->
        <!-- <div dw-col>
                    <dw-form-input class="change_password_input" formControlName="new_password"
                        dwLabel="{{'新密码' | translate}}" [dwRequired]="true">
                    </dw-form-input>
                </div>
                <div dw-col>
                    <dw-form-input class="change_password_input" formControlName="sure_password"
                        dwLabel="{{'确认密码' | translate}}" [dwRequired]="true">
                    </dw-form-input>
                </div> -->

        <!-- </div> -->



        <!-- <div class="input-group">
                        <span  class="input-group-addon change_password_title">新密码</span>
                        <i class="anticon anticon-eye-o change_password_eye" [ngClass]="{'eye_blue':showPassword1}" (click)="showPassword1 = !showPassword1"></i>
                        <input class="change_password_input"   dw-input [type]="showPassword1 ? 'text' : 'password'" formControlName="new_password" placeholder="{{'dw-forget-enterNewPassword'|translate}}">
                       
                </div>
                <div class="input-group">
                        <span  class="input-group-addon change_password_title">确认密码</span>
                        <i class="anticon anticon-eye-o change_password_eye" [ngClass]="{'eye_blue':showPassword2}" (click)="showPassword2 = !showPassword2"></i>
                        <input class="change_password_input"   dw-input [type]="showPassword2 ? 'text' : 'password'" formControlName="new_password" placeholder="{{'dw-forget-enterNewPassword'|translate}}">
                       
                </div> -->

        <span *ngIf='!Flag'  class="password-input-g-span red">基于安全性考量，密码变更后，系统会自动登出，
            请使用新密码重新登入</span>



<!-- </div> -->

</form>
</div>